<template>
    <div class="one-to-one__section">

        <div class="grid">
            <div class="grid__item desktop--6">
                <h2 class="one-to-one__section-title">{{ $t("is-sentimental-potential") }}</h2>

                <ul
                    class="flower-list"
                    v-if="partnerContent">
                    <li
                        class="flower-list__item"
                        v-for="(item, index) in partnerContent"
                        :key="'partner-' + index">
                        <span class="flower-list__item-content">
                            {{ item }}
                        </span>
                    </li>
                </ul>

            </div>
            <div class="grid__item desktop--6">
                <h2 class="one-to-one__section-title">{{ $t("your-sentimental-potential") }}</h2>

                <ul
                    class="flower-list"
                    v-if="userContent">
                    <li
                        class="flower-list__item"
                        v-for="(item, index) in userContent"
                        :key="'user-' + index">
                        <span class="flower-list__item-content">
                            {{ item }}
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

import { capitalize } from "@/utils/helpers/string.js";

export default {
    name: "SentimentalPotentialSection",
    props: {
        data: {
            type: Array,
            required: true
        },
        partnerId: {
            type: String,
            required: true,
        },
        userId: {
            type: String,
            required: true,
        }
    },
    data () {
        return {};
    },
    computed: {
        partner() {
            return this.data.find(item => item.id_person === this.partnerId);
        },
        user() {
            return this.data.find(item => item.id_person === this.userId);
        },
        partnerContent() {

            const content = this.partner.desc.split(",");

            const cleanedContent = content.map((item) => {
                return capitalize(item.trim());
            });

            return cleanedContent.filter((item) => {
                return item != null && item != "";
            });
        },
        userContent() {

            const content = this.user.desc.split(",");

            const cleanedContent = content.map((item) => {
                return capitalize(item.trim());
            });

            return cleanedContent.filter((item) => {
                return item != null && item != "";
            });
        }
    },
    mounted: function() {
    },
};

</script>